import { useEffect } from 'react';
import { useActor } from '@xstate/react';
import { v4 as uuid } from 'uuid';

import { CodeBox } from '/src/components/CodeBox';
import { generateCodeGoalScript } from '/src/features/goals/utils';
import { GOAL_ACTIONS } from '/src/features/goals/machines/wizard';

export function CodeTrigger({ service, triggerIndex }) {
  const [state] = useActor(service);
  const { send } = service;
  // const [triggerField] = useField(`triggers.${triggerIndex}.trigger`);

  const values = state.context.payload.triggers[triggerIndex];

  useEffect(() => {
    if (!values.code) {
      send({ type: GOAL_ACTIONS.SET_TRIGGER, index: triggerIndex, key: 'code', value: uuid() });
    }
  }, [send, triggerIndex, values.code]);

  if (!values.code) return null;

  return (
    <>
      <div>
        <h2 className="text-header-2 mb-5">Execute this HTML snippet when the conversion event is triggered:</h2>
        <CodeBox
          loading={false}
          code={generateCodeGoalScript(values, values.code)}
          canCopy={true}
          className="!max-h-none"
        />

        <div className="text-body-2 my-10 ml-2 flex flex-col leading-6 text-black-pearl-500	">
          <h3 className="text-header-4 mb-2.5">General instructions:</h3>
          <div className="flex">
            <strong className="w-6">1.</strong>
            <span>Copy the code snippet</span>
          </div>
          <div className="flex mb-5">
            <strong className="w-6">2.</strong>
            <span>Place the code snippet on the page before the standard Crazy Egg tracking script.</span>
          </div>

          <h3 className="text-header-4 mb-2.5">For Google Tag Manager users:</h3>
          <div className="flex">
            <strong className="w-6">1.</strong>
            <span>Copy the code snippet</span>
          </div>
          <div className="flex">
            <strong className="w-6">2.</strong>
            <span>Create a new &quot;Custom HTML&quot; tag.</span>
          </div>
          <div className="flex">
            <strong className="w-6">3.</strong>
            <span>Paste the code snippet in the HTML text box.</span>
          </div>
          <div className="flex">
            <strong className="w-6">4.</strong>
            <span>Choose the relevant Trigger for your conversion event.</span>
          </div>
          <div className="flex">
            <strong className="w-6">5.</strong>
            <span>Save the Tag, then submit changes to your Container.</span>
          </div>
        </div>

        <span className="text-body-2 text-lynch-500">
          <strong>Note:</strong> This is a feature for advanced users. If you aren&apos;t sure how to implement this
          code snippet, we recommend using the other tracking options.
        </span>
      </div>
    </>
  );
}
